import React, { useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import WelcomeScreen from '@/components/WelcomeScreen';
import QuestionnaireFlow from '@/components/QuestionnaireFlow';
import LeadCaptureScreen from '@/components/LeadCaptureScreen';
import ResultsScreen from '@/components/ResultsScreen';

function App() {
  const [businessInfo, setBusinessInfo] = useState(null);
  const [assessmentResult, setAssessmentResult] = useState(null);
  const [, setLead] = useState(null);

  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <WelcomeScreen
                onStart={(info) => setBusinessInfo(info)}
                businessInfo={businessInfo}
              />
            }
          />
          <Route
            path="/questionnaire"
            element={
              <QuestionnaireFlow
                businessInfo={businessInfo}
                onAssessmentReady={(result) => setAssessmentResult(result)}
              />
            }
          />
          <Route
            path="/lead-capture"
            element={
              <LeadCaptureScreen
                assessment={assessmentResult}
                onLeadCaptured={(lead) => setLead(lead)}
              />
            }
          />
          <Route
            path="/results"
            element={<ResultsScreen assessment={assessmentResult} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
